import { useMemo } from 'react';
import { useRecordContext } from 'react-admin';
import { useParams } from 'react-router-dom';
import get from 'lodash/get';
import { useRunRequest } from '@/hooks';
import { FCRAWorkerAddressEnum, TurnActionsEnum, TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';

const useController = () => {
  const record = useRecordContext();
  const { runRequest } = useRunRequest();
  const { id: workerId } = useParams<{ id: string }>();

  const canSetCurrentAddress = useMemo(() => {
    const isCurrentAddress = get(record, FCRAWorkerAddressEnum.IsCurrentAddress);
    const active = get(record, FCRAWorkerAddressEnum.Active);
    return !isCurrentAddress && active;
  }, [record]);

  const setCurrentAddress = async () => {
    await runRequest({
      fetchType: 'UPDATE',
      resource: TurnResourcesEnum.FcraWorkers,
      params: {
        id: workerId,
        target: TurnTargetsEnum.Addresses,
        targetId: record.id,
        action: TurnActionsEnum.SetCurrentAddress,
      },
      mode: 'notify',
      notify: {
        onError: { message: 'Error: Current address was not updated' },
        onSuccess: { message: 'Current address updated' },
      },
    });
  };

  return {
    canSetCurrentAddress,
    setCurrentAddress,
  };
};

export default useController;
